import { render, staticRenderFns } from "./PersonSearchModal.vue?vue&type=template&id=84c65d30&scoped=true&"
import script from "./PersonSearchModal.vue?vue&type=script&lang=ts&"
export * from "./PersonSearchModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c65d30",
  null
  
)

export default component.exports